import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from '@material-ui/core';
import { FormControl, FormHelperText } from '@material-ui/core';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Switch from '@material-ui/core/Switch';
import { TextField } from '@material-ui/core';
import { AttributeType } from 'models/Attributes.js';
import styles from './styles';

const maxWidth = 'sm'; // alternatives: xs, sm, md, lg, xl

function DialogOption({ classes, applications, mask, idx, error, onUpdate }) {
    const [selection, setSelection] = useState("");

    const onChange = (event) => {
        onUpdate(mask.path)(event.target.value);
        setSelection(event.target.value);
    }

    const getOptions = () => {
        if (AttributeType[mask.type] == AttributeType.Boolean) {
            return ['true', 'false']
        }

        if (mask.options) {
            return mask.options;
        } else if (mask.applicationObject) {
            const {application, objectsName} = mask.applicationObject;
            if (applications?.apps[application] == undefined) {
                return null; // Loading
            }
            const applicationObjects = applications.apps[application].applicationObjects.find(
                appObjs => (appObjs.objectsName == objectsName));
            
            return applicationObjects.list.map(appObj => appObj.id);
        }
        return null;
    }

    switch (AttributeType[mask.type]) {
        case AttributeType.String:
            return (
                <TextField
                    error={error == mask.path.split('.')[0]}
                    autoFocus={idx == 0}
                    margin="dense"
                    id={`dialog_value_${mask.path}`}
                    label={mask.name}
                    type="text"
                    helperText={mask.help}
                    fullWidth
                    required={mask.required}
                    onChange={onChange}
                />
            );
        case AttributeType.Boolean:
        case AttributeType.OptionString:
            return (
                <FormControl fullWidth className={classes.formControl} required={mask.required}>
                    <InputLabel id={`dialog_option_${mask.path}_label`}>
                        {`Select ${mask.name}`}
                    </InputLabel>
                    <Select
                        error={error == mask.path.split('.')[0]}
                        autoFocus={idx == 0}
                        labelId={`dialog_option_${mask.path}_label`}
                        id={`dialog_option_${mask.path}_value`}
                        value={selection}
                        onChange={onChange}
                    >
                        {(mask.required) ? null : <MenuItem key={`menu_item_null`} value={""}></MenuItem>}
                        {(getOptions().map((option) => (
                            <MenuItem key={`menu_item_${option}`} value={option}>{option}</MenuItem>
                        )))}
                    </Select>
                    <FormHelperText>{mask.help}</FormHelperText>
                </FormControl>
            );
        default:
            return null;
    }
}

function ObjectCreateDialog({ classes, applications, applicationObjects, onClose, selectObject, accountId, authData }) {
    const [inputValues, setInputValues] = useState({});
    const [error, setError] = useState("");

    const onUpdateInput = (attributePath) => (value) => {
        inputValues[attributePath] = value;
        setInputValues(inputValues);
    }

    const checkRequired = () => {
        for (let mask of applicationObjects.attributesMask) {
            if (mask.required && !inputValues[mask.path] && !mask.createDefault) {
                setError(mask.path);
                console.log(`Required but not provided: ${mask.path}`)
                return false;
            }
        }
        setError("");
        return true;
    }

    const onCreate = () => {
        console.log({inputValues, accountId});
        if (checkRequired()) {
            applicationObjects.createObject(authData, accountId, inputValues).then(
                (applicationObject) => { 
                    selectObject(applicationObject)();
                    onClose();
                }
            ).catch(
                ({status, error}) => {
                    console.log({status, error});
                    if (error?.param != undefined) {
                        setError(error.param);
                    }
                }
            )
        }
    }

    return (
        <Dialog
            fullWidth={true}
            maxWidth={maxWidth}
            onClose={onClose}
            open={true}
            aria-labelledby="max-width-dialog-title"
        >
            <DialogTitle id="max-width-dialog-title">
                {`Create new ${applicationObjects.objectName}`}
            </DialogTitle>
            <DialogContent>
                {applicationObjects.attributesMask.filter(mask => (mask.update || (mask.required && mask.visible))).map((mask, idx) => (
                    <DialogContentText key={`dialog-input-${mask.path}`}>
                        <DialogOption classes={classes} applications={applications} mask={mask} idx={idx} error={error} onUpdate={onUpdateInput}/>
                    </DialogContentText>
                ))}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="secondary">
                    Close
                </Button>
                <Button 
                    onClick={onCreate} 
                    color="primary">
                    Create
                </Button>
            </DialogActions>
        </Dialog>
    );
}

ObjectCreateDialog.propTypes = {
	classes: PropTypes.object.isRequired,
    applications: PropTypes.object.isRequired,
    applicationObjects: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired,
    selectObject: PropTypes.func.isRequired,
    accountId: PropTypes.string.isRequired,
    authData: PropTypes.object.isRequired
}

export default withStyles(styles)(ObjectCreateDialog)